import { Link } from "react-router-dom";
import "./ProductCard.css";

const ProductCard = ({ product, onAddToCart }) => {
  const handleAddToCart = () => {

    onAddToCart(product);
    alert(`${product.name} aggiunto al carrello!`);
  };

  return (
    <div className="product-card">
      <Link to={`/product/${product.id}`} className="product-image-link">
        <div className="product-image">
          <img src={product.image} alt={product.name} className="product-img" />
        </div>
      </Link>

      <div className="product-info">
        <Link to={`/product/${product.id}`} className="product-name-link">
          <h3 className="product-name">{product.name}</h3>
        </Link>

        <p className="product-description">{product.shortDesc}</p>

        <div className="product-rating">
          <span className="stars">★★★★★</span>
          <span className="rating-count">({product.reviews} recensioni)</span>
        </div>

        <div className="product-price">
          <span className="price">€{product.price.toFixed(2)}</span>
          {product.discount && (
            <span className="discount">-{product.discount}%</span>
          )}
        </div>

        <div className="product-stock">
          {product.stock > 0 ? (
            <span className="in-stock">✓ Disponibile</span>
          ) : (
            <span className="out-of-stock">Non disponibile</span>
          )}
        </div>

        <button
          className="add-to-cart-btn"
          onClick={handleAddToCart}
          disabled={product.stock === 0}
        >
          🛒 Aggiungi al Carrello
        </button>
      </div>
    </div>
  );
};

export default ProductCard;
